import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { StyledLabel } from 'elements/Label/Label';
import { StyleHMINewDropdown } from '../HMISection/HMISection.styled';
import { selectSignalToTrigger } from './SignalToTrigger.data';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

const SignalToTrigger = (props) => {
    const { selectedTag, changeHandler, formData, formName, isFormReadOnly } = props;
    const classes = useStyles();
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectSignalToTrigger(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {
                                    field.isLabel
                                        ? (
                                            <StyledLabel
                                                id={field.key}
                                                fontWeight={field.fontWeight}
                                                textAlign={field.textAlign}
                                                labelWidth={field.labelWidth}
                                                padding={field.padding}
                                                fontSize={field.fontSize}
                                                color={field.color}
                                            >
                                                {field.label}
                                            </StyledLabel>
                                        )
                                        : (
                                            <StyleHMINewDropdown
                                                formName={formName}
                                            >
                                                <FormDropdown
                                                    id={field.key}
                                                    name={field.key}
                                                    label={field.label}
                                                    value={field.value}
                                                    placeholder={field.placeholder}
                                                    handleChange={changeHandler}
                                                    options={field.options}
                                                    isRequired={field.isRequired}
                                                    marginLeft={field.marginLeft}
                                                    width={field.width}
                                                    labelWidth={field.labelWidth}
                                                    readOnly={isFormReadOnly}
                                                    inputTextAlign={field.inputTextAlign}
                                                    paddingRightPlaceholder={field.paddingRightPlaceholder}
                                                    marginTop={field.marginTop}
                                                    marginBottom={field.marginBottom}
                                                    direction={field.direction}
                                                    marginRight={field.marginRight}
                                                />
                                            </StyleHMINewDropdown>
                                        )
                                }
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag,
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SignalToTrigger);

SignalToTrigger.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
};
